import { Component, OnInit } from '@angular/core';
import { Code } from './../../code/switch';

@Component({
  templateUrl: './switch.component.html'
})
export class SwitchComponent implements OnInit {

  	code = Code;
  	checked1: boolean = false;
    checked2: boolean = true;

	parameters: any[];
	eventHeader: any[];
	eventValue: any[];
	styleHeader: any[];
	styleValue: any[];
	items: any[]; 
	headers: any[];
	  constructor() { }

	  ngOnInit() {
	  	this.items = [
	        {label: 'Update', icon: 'fa ion-refresh', command: () => {
	            console.log(1)
	        }},
	        {label: 'Delete', icon: 'fa ion-close', command: () => {
	            console.log(2)
	        }},
	        {label: 'Angular.io', icon: 'fa-link', url: 'http://angular.io'},
	        {label: 'Theming', icon: 'fa-paint-brush', routerLink: ['/theming']}
	    ];
	  	this.parameters = [
	        {name: "onLabel",type: "string",default: "On",des: "开启状态按钮的文字显示"},
	        {name: "offLabel",type: "string",default: "Off",des: "关闭状态按钮的文字显示"},
	        {name: "style",type: "string",default: "null",des: "组件行内样式"},
	        {name: "styleClass",type: "string",default: "null",des: "组件class样式"},
	        {name: "tabindex",type: "number",default: "null ",des: "列表中元素索引"},
	        {name: "inputId",type: "string",default: "null ",des: "指示元素的方向"},
	        {name: "ariaLabelTemplate",type: "string",default: "InputSwitch {0}",des: "ARIL标签模板用于定义标记当前E的字符串。"}
	    ];
	    
	    this.headers = [
	        {name : "名字"},
	        {name : "类型"},
	        {name : "默认"},
	        {name : "描述"}
	    ];

	    this.eventHeader = [
	    	{name : "名字"},
	        {name : "参数"},
	        {name : "描述"}
	    ];

	    this.eventValue = [
	    	{name : "onClick",param : "1.事件：浏览器事件 2.事件：检查状态为布尔值",event :"回调以调用状态更改。" }
	    ];

	    this.styleHeader = [
	    	{name : "名字"},
	        {name : "元素"}
	    ];

	    this.styleValue = [
	    	{name : "ui-inputswitch",el : "容器元素"},
	    	{name : "ui-inputswitch-on",el : "选中元素状态"},
	    	{name : "ui-inputswitch-off",el : "未选中元素状态"},
	    ];
	  }

}



// WEBPACK FOOTER //
// ./src/app/view/switch/switch.component.ts